import { AfterViewInit, Component, OnInit } from '@angular/core';
import { EnvironmentService } from 'src/app/services/environment/environment.service';

// Web fallback for the domiiDetect link texted to agents when a guest signs into
// their open house (https://account.domii.io/detect?phone=…&firstName=…&lastName=…).
// With domii installed the OS opens the app instead (see .well-known); this page
// only shows when it isn't, so it asks the agent to download domii and sign in.
@Component({
  selector: 'app-domii-detect-landing',
  templateUrl: './domii-detect-landing.component.html'
})
export class DomiiDetectLandingComponent implements OnInit, AfterViewInit {

  androidStoreUrl: string;
  iOSStoreUrl: string;

  constructor(
    private environmentService: EnvironmentService) { }

  ngOnInit(): void {
    this.androidStoreUrl = this.environmentService.getAndroidStoreUrl();
    this.iOSStoreUrl = this.environmentService.getiOSStoreUrl();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const btn = document.getElementById('openDetectBtn');
      if (btn) btn.click();
    }, 0);
  }

  openAppStore() {
    window.open(this.iOSStoreUrl);
  }

  openPlayStore() {
    window.open(this.androidStoreUrl);
  }
}
